import { render, staticRenderFns } from "./aRmsStrategyDayTable.vue?vue&type=template&id=28af41f2&scoped=true"
import script from "./aRmsStrategyDayTable.vue?vue&type=script&lang=js"
export * from "./aRmsStrategyDayTable.vue?vue&type=script&lang=js"
import style0 from "./aRmsStrategyDayTable.vue?vue&type=style&index=0&id=28af41f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28af41f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
